import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import Papa from 'papaparse';

const DragDropCSV = ({ onDataFrameChange }) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [icon, setIcon] = useState('fa-upload');
  const [iconColor, setIconColor] = useState('#cccccc');

  const onDrop = useCallback(async (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file) {
      setLoading(true);
      setMessage('');
      setIcon('fa-spinner fa-spin');
      setIconColor('#cccccc');

      await new Promise((resolve) => setTimeout(resolve, 1000));

      Papa.parse(file, {
        complete: async (result) => {
          const data = result.data;

          if (data.length > 1) {
            const headers = data[0];
            const valueIndex = 0;
            const positivityIndex = 1;

            const rows = data.slice(1).map((row) => ({
              value: parseFloat(row[valueIndex]),
              positivity: parseInt(row[positivityIndex], 10),
            }));

            if (rows.length > 0) {
              if (typeof onDataFrameChange === 'function') {
                onDataFrameChange(rows);
                setMessage('Upload Complete!');
                setIcon('fa-check-circle');
                setIconColor('green');
              } else {
                console.error('onDataFrameChange prop is not a function');
                setMessage('Error: Callback function not found');
                setIcon('fa-times-circle');
                setIconColor('red');
              }
            } else {
              console.error('No valid data rows found in the CSV');
              setMessage('No valid data rows found in the CSV');
              setIcon('fa-times-circle');
              setIconColor('red');
            }
          } else {
            console.error('No data rows found in the CSV');
            setMessage('No data rows found in the CSV');
            setIcon('fa-times-circle');
            setIconColor('red');
          }

          await new Promise((resolve) => setTimeout(resolve, 1000));

          setLoading(false);
        },
        error: (error) => {
          console.error('Parsing Error:', error.message);
          setMessage(`Parsing Error: ${error.message}`);
          setIcon('fa-times-circle');
          setIconColor('red');
          setLoading(false);
        },
        header: false, // Assumes the first row is not a header
      });
    } else {
      console.error('No file uploaded');
      setMessage('No file uploaded');
      setIcon('fa-times-circle');
      setIconColor('red');
      setLoading(false);
    }
  }, [onDataFrameChange]);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: '.csv',
  });

  return (
    <div
      {...getRootProps()}
      style={{
        border: '2px dashed #cccccc',
        padding: '100px 20px',
        textAlign: 'center',
        cursor: 'pointer',
        borderRadius: '10px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <input {...getInputProps()} />
      <i className={`fa-solid ${icon}`} style={{ fontSize: '36px', color: iconColor }}></i>
      <p className='mt-3 mb-0'>
        {loading ? 'Uploading...' : message || 'Drag and drop a CSV file here, or click to select one'}
      </p>
    </div>
  );
};

export default DragDropCSV;
